import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Label } from "../../../../../../components/formInputs";
import { NumberTextField, TextField } from "../../../../../../components/formikFormInputs";
import { useGwtV2 } from "../../../../../../hooks/isGwtV2";
import { unmaskCurrency } from "../../../../../../utils/commonUtils";

type IndividualIncomeProp = {
    CommonField: Function;
    conditionalRequired: boolean;
    currentlyEmployed: string;
    errors: any;
    financiallyDependent: boolean;
    handleBlur: Function;
    handleChange: Function;
    isGiftorAgentInvite?: boolean;
    isGiftorPortal?: boolean;
    setFieldValue: Function;
    touched: any;
    values: any;
}
type AllFieldsProps = {
    lastYearArr: any,
    CommonField: Function,
    values: any,
    errors: any,
    touched: any,
    handleChange: Function,
    handleBlur: Function,
    setFieldValue: Function,
    yearsArr: any,
    prefixText: string
}
export const AllFields = (props: AllFieldsProps) => {
    const {
        lastYearArr,
        CommonField,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
        yearsArr,
        prefixText
    } = props;

    const {
        indIncomeLastYearAnnualSalary, indIncomeLastYearDividends, indIncomeLastYearOtherIncome,
        indIncome1YearsPriorAnnualSalary, indIncome1YearsPriorDividends, indIncome1YearsPriorOtherIncome,
        indIncome2YearsPriorAnnualSalary, indIncome2YearsPriorDividends, indIncome2YearsPriorOtherIncome,
    } = values;

    React.useEffect(() => {
        const total1 = Number(unmaskCurrency(indIncomeLastYearAnnualSalary)) + Number(unmaskCurrency(indIncomeLastYearDividends)) + Number(unmaskCurrency(indIncomeLastYearOtherIncome));
        setFieldValue("indIncomeLastYearTotal", total1);
        const total2 = Number(unmaskCurrency(indIncome1YearsPriorAnnualSalary)) + Number(unmaskCurrency(indIncome1YearsPriorDividends)) + Number(unmaskCurrency(indIncome1YearsPriorOtherIncome));
        setFieldValue("indIncome1YearsPriorTotal", total2);
        const total3 = Number(unmaskCurrency(indIncome2YearsPriorAnnualSalary)) + Number(unmaskCurrency(indIncome2YearsPriorDividends)) + Number(unmaskCurrency(indIncome2YearsPriorOtherIncome));
        setFieldValue("indIncome2YearsPriorTotal", total3);
    }, [indIncomeLastYearAnnualSalary, indIncomeLastYearDividends, indIncomeLastYearOtherIncome, indIncome1YearsPriorAnnualSalary, indIncome1YearsPriorDividends, indIncome1YearsPriorOtherIncome, indIncome2YearsPriorAnnualSalary, indIncome2YearsPriorDividends, indIncome2YearsPriorOtherIncome]);

    return (<>
        {
            yearsArr.map((item, index) => {
                return <Grid item xs={12} md={6} xl={4} key={index}>
                    <Typography variant="caption"
                                className="w100 mb15 floatLeft">{item.label}</Typography>
                    <Grid container spacing={2}>
                        {lastYearArr.map((field, index) => {
                            return (
                                    <Grid item xs={12} key={`indIncome${item.name}${field.name}`}>
                                        <div className="mb15">
                                            {
                                                CommonField(
                                                        {
                                                            ...field,
                                                            name: `${prefixText}${item.name}${field.name}`,
                                                            id: `${prefixText}${item.name}${field.name}`,
                                                        },
                                                        {
                                                            values,
                                                            errors,
                                                            touched,
                                                            handleChange,
                                                            handleBlur,
                                                            setFieldValue,
                                                        },
                                                )
                                            }
                                        </div>
                                    </Grid>
                            );
                        })}
                    </Grid>
                </Grid>;
            })

        }
    </>);
};
export const allFieldsArr = (conditionalRequired: boolean, isGWTRequired?: boolean, disableTotal?: boolean, isGiftorAgentInvite?: boolean) => {
    return [
            {
        id: "AnnualSalary",
        name: "AnnualSalary",
        label: <Label label={"Annual Salary"} required={!isGiftorAgentInvite || isGWTRequired}/>,
        //isRequired: conditionalRequired,
        isRequired: !isGiftorAgentInvite,
        component: NumberTextField,
        variant: "outlined",
        className: "TextFieldWidth dollerIcon",
        dollarSign: true,
    },
        {
        id: "Dividends",
        name: "Dividends",
        label: <Label label={"Dividends etc"} required={false}/>,
        //isRequired: conditionalRequired,
        isRequired: false,
        component: NumberTextField,
        variant: "outlined",
        className: "TextFieldWidth dollerIcon",
        dollarSign: true,
    },
        {
        id: "OtherIncome",
        name: "OtherIncome",
        label: <Label label={"Other Income"} required={false}/>,
        //isRequired: conditionalRequired,
        isRequired: false,
        component: NumberTextField,
        variant: "outlined",
        className: "TextFieldWidth dollerIcon",
        dollarSign: true,
    },
        {
        id: "Total",
        name: "Total",
        label: <Label label={"Last Year Total"} required={false}/>,
        //isRequired: conditionalRequired,
        isRequired: false,
        component: NumberTextField,
        variant: "outlined",
        className: "TextFieldWidth dollerIcon",
        dollarSign: true,
        disabled: disableTotal
    }];
};

function IndividualIncome(props: IndividualIncomeProp) {
    const {
        CommonField,
        conditionalRequired,
        currentlyEmployed,
        errors,
        financiallyDependent,
        handleBlur,
        handleChange,
        isGiftorAgentInvite,
        isGiftorPortal,
        setFieldValue,
        touched,
        values,
    } = props;
    const isGWTGenV2 = useGwtV2();
    const isGWTRequired:any = isGWTGenV2 && !financiallyDependent && (values["currentlyEmployed"] === "PART_TIME" || values["currentlyEmployed"] === "FULL_TIME" || values["currentlyEmployed"] === "SELF_EMPLOYED");
    const disableTotal: boolean = true;
    const indYearsArr = [
        { label: (<>{isGiftorPortal ? "Giftor" : "Individual"} Income <strong>last year</strong></>), name: "LastYear" },
        { label: (<>{isGiftorPortal ? "Giftor" : "Individual"} Income <strong>1 year prior</strong></>), name: "1YearsPrior" },
        { label: (<>{isGiftorPortal ? "Giftor" : "Individual"} Income <strong>2 year prior</strong></>), name: "2YearsPrior" },
    ];
    const lastYearArr = allFieldsArr(conditionalRequired, isGWTRequired, disableTotal, isGiftorAgentInvite);

    const otherIncome = [
            {
        name: "indOtherIncomeDetail",
        label: <Label label={"Other Income Details"} required={false}/>,
        isRequired: false,
        component: TextField,
        variant: "outlined",
        className: "TextFieldWidth",
    }
    ];

    const individualNetWorth = [
            {
        id: "netWorth",
        name: "netWorth",
        label: <Label label={ isGiftorPortal ? "Giftor Net Worth" : "Individual Net Worth"} required={isGiftorPortal || isGWTRequired}/>,
        isRequired: !isGiftorAgentInvite || isGWTRequired,
        component: NumberTextField,
        variant: "outlined",
        className: "TextFieldWidth dollerIcon",
        dollarSign: true,
    }
    ];

    return <>
        <Grid item xs={12}>
            <div className="hLine"/>
        </Grid>
        {isGWTGenV2 && (currentlyEmployed === 'NO' || financiallyDependent) && <Typography variant="h6" className="colorRed">If you are a dependent or do not have an income, you do not have to fill out these fields.</Typography>}
        <Grid item xs={12}>
            <Typography variant="h6" component="strong" className="w100">{isGiftorPortal ? "Giftor Income" : "Individual Income"}</Typography>
        </Grid>
        <AllFields lastYearArr={lastYearArr} CommonField={CommonField} values={values}
                   errors={errors} handleChange={handleChange} handleBlur={handleBlur}
                   setFieldValue={setFieldValue} yearsArr={indYearsArr} touched={touched}
                   prefixText="indIncome" />
        <Grid item xs={12}>
            <Grid container spacing={2}>
                {
                    otherIncome.map((field, index) => {
                        return (
                                <Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
                                    <div className="mb15">
                                        {
                                            CommonField(
                                                    field,
                                                    {
                                                        values,
                                                        errors,
                                                        touched,
                                                        handleChange,
                                                        handleBlur,
                                                        setFieldValue,
                                                    },
                                            )
                                        }
                                    </div>
                                </Grid>
                        );
                    })
                }
            </Grid>
        </Grid>

        <Grid item xs={12}>
            <Typography variant="h6" component="strong" className="mb0 w100 floatLeft">
                {isGiftorPortal ? "Giftor" : "Individual"} Net Worth
            </Typography>
        </Grid>
        {
            individualNetWorth.map((field, index) => {
                return (
                        <Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
                            <div>
                                {
                                    CommonField(
                                            field,
                                            {
                                                values,
                                                errors,
                                                touched,
                                                handleChange,
                                                handleBlur,
                                                setFieldValue,
                                            },
                                    )
                                }
                            </div>
                        </Grid>
                );
            })
        }
        <Grid item xs={12}>
            <div className="hLine"/>
        </Grid>
    </>;
}

export default IndividualIncome;